/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import TextField from '@material-ui/core/TextField';
import React, { useCallback } from 'react';
import TooltipTextField from '../../../../SharedModules/Tooltip/TooltipTextField';
import { isReadOnly as readOnly } from '../../../../SharedModules/utilities/utilities';
import { useSelector } from 'react-redux';
export default (props) => {
  const { isEnablebyRole } = props;
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly =
      readOnly(window.location.pathname, loginState)?.readOnly || false;
  }
  const checkedHandler = (e) => {
    let value = e.target.value;
    let colId = props.column.colId;
    props.node.setDataValue(colId, value);
    if (props.handleBlur) {
      optimiseValidationCall(props.compareData);
    }
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 300);
    };
  };

  const optimiseValidationCall = useCallback(debounce(props.handleBlur), []);

  return (
    <div className="form-wrapper vertical-wrapper">
      <label
        className="m-0 hide-elm"
        htmlFor={'contactId' + props.column.colId}
      >
        <span>label</span>{' '}
      </label>
      <TooltipTextField
        className="custom_fullWidth"
        id="contact_type"
        fullWidth
        placeholder=""
        inputProps={{ maxlength: 60, 'aria-labelledby': 'contact_type' }}
        InputLabelProps={{
          shrink: true,
        }}
        value={props.value}
        onChange={checkedHandler}
        tooltipContent={props.value}
        tooltipTriggerLength={15}
        disabled={isReadOnly || !isEnablebyRole}
        onKeyDown={(e) => {
          // if ((e.key === 'Tab' && !e.shiftKey) || e.key === 'ArrowRight') {
          //   props.addAction();
          // }
        }}
      />
    </div>
  );
};
